export const SOCKET_IO = 'socket-io';
export const PUBNUB = 'pubnub';
